import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

axios.defaults.withCredentials = true;

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [authOpen, setAuthOpen] = useState(false);
  const [authMode, setAuthMode] = useState('login'); // 'login' | 'register'

  const checkAuth = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/auth/me`);
      setUser(res.data);
    } catch (e) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const openAuth = (mode = 'login') => {
    setAuthMode(mode);
    setAuthOpen(true);
  };
  const closeAuth = () => setAuthOpen(false);

  const register = async ({ name, email, password }) => {
    const res = await axios.post(`${API}/auth/register`, { name, email, password, app_url: window.location.origin });
    setUser(res.data);
    // merge any guest kit items saved locally
    try {
      const raw = localStorage.getItem('botanica_kit_v1');
      const parsed = raw ? JSON.parse(raw) : { items: [] };
      if (parsed.items?.length) await axios.post(`${API}/kit/merge`, { items: parsed.items });
    } catch (e) {
      /* ignore */
    }
    return res.data;
  };

  const signin = async ({ email, password }) => {
    const res = await axios.post(`${API}/auth/login`, { email, password });
    setUser(res.data);
    try {
      const raw = localStorage.getItem('botanica_kit_v1');
      const parsed = raw ? JSON.parse(raw) : { items: [] };
      if (parsed.items?.length) await axios.post(`${API}/kit/merge`, { items: parsed.items });
    } catch (e) {
      /* ignore */
    }
    return res.data;
  };

  const logout = async () => {
    try {
      await axios.post(`${API}/auth/logout`);
    } catch (e) {
      /* ignore */
    }
    setUser(null);
  };

  return (
    <AuthContext.Provider
      value={{ user, setUser, loading, authOpen, authMode, openAuth, closeAuth, register, signin, logout }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
